<template>
  <v-layout class="presentacion-modulo" column fill-height text-xs-center>
    <div class="logo animated fadeInUp">
      <img src="../assets/imagenes_compartidas/logo_ecopetrol.png">
    </div>
    <h1 class="animated fadeInUp dura-1">{{datos.titulo}}</h1>
    <h2  class="animated fadeInUp dura-2">{{datos.nombreModulo}}</h2>
    <p  class="animated fadeInUp dura-2">{{datos.texto}}</p>
  </v-layout>
</template>
<script>
export default {
  props: ['datos'],
  data() {
    return {
    }
  },
  created(){
    this.$store.commit("nextShow", true);
  }
}
</script>
<style lang="scss" scoped>
.presentacion-modulo{
  // margin-left: 45px;
  margin-right: 0;
  padding-top: 10vh;
  font-family: 'helveticaNeueCn', Helvetica, sans-serif;

  @media (max-width: 600px) {
    margin-left: 0;
    margin-bottom: 45px;      
  }

  .logo{
    // background-color: rgba(255, 255, 255, 0.9);
    width: 100%;
    text-align: center;
    img{
      background-color: white;
      padding: 10px;
      max-width: 60vw;
      max-height: 20vh;
      margin-right: 50px;
    }
  }

  // Celulares

  h1, h2, p{
    margin-top: 5px;
    padding: 0 20px;
  }

  h1 {
    margin-bottom: 5px;
  }

  // Pantallas más grandes

  @media (min-width: 700px) and (min-height: 500px){
    font-size: 1.5rem;

    h1, h2, p{
      margin-top: 10px;
      padding: 0 20px;
    }
  
    h1{
      margin-bottom:20px;
    }
  
    p {
      font-size: 1.3em;
    }
  }

}
</style>
